export class WebsocketSubscription {
    options;
    gateway;
    constructor(gateway, options) {
        this.gateway = gateway;
        this.options = options;
    }
    subscribe() {
        const { dataSchema, userId, handler, channel } = this.options;
        let subscription;
        const onPublication = (ctx) => {
            handler(dataSchema.parse(ctx.data));
        };
        this.gateway.onConnected((client) => {
            if (subscription) {
                return;
            }
            const channelName = `${channel}:${userId}`;
            subscription =
                client.getSubscription(channelName) ??
                    client.newSubscription(channelName);
            subscription.on("publication", onPublication);
            if (subscription.state === "unsubscribed") {
                subscription.subscribe();
            }
        });
        return () => {
            subscription?.off("publication", onPublication);
            subscription?.unsubscribe();
        };
    }
}
export default WebsocketSubscription;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiV2Vic29ja2V0U3Vic2NyaXB0aW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2FwaS9XZWJzb2NrZXRTdWJzY3JpcHRpb24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBYUEsTUFBTSxPQUFPLHFCQUFxQjtJQUNmLE9BQU8sQ0FBa0M7SUFDekMsT0FBTyxDQUFtQjtJQUUzQyxZQUNFLE9BQXlCLEVBQ3pCLE9BQXdDO1FBRXhDLElBQUksQ0FBQyxPQUFPLEdBQUcsT0FBTyxDQUFDO1FBQ3ZCLElBQUksQ0FBQyxPQUFPLEdBQUcsT0FBTyxDQUFDO0lBQ3pCLENBQUM7SUFFTSxTQUFTO1FBQ2QsTUFBTSxFQUFFLFVBQVUsRUFBRSxNQUFNLEVBQUUsT0FBTyxFQUFFLE9BQU8sRUFBRSxHQUFHLElBQUksQ0FBQyxPQUFPLENBQUM7UUFFOUQsSUFBSSxZQUFzQyxDQUFDO1FBRTNDLE1BQU0sYUFBYSxHQUFHLENBQUMsR0FBdUIsRUFBUSxFQUFFO1lBQ3RELE9BQU8sQ0FBQyxVQUFVLENBQUMsS0FBSyxDQUFDLEdBQUcsQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDO1FBQ3RDLENBQUMsQ0FBQztRQUVGLElBQUksQ0FBQyxPQUFPLENBQUMsV0FBVyxDQUFDLENBQUMsTUFBTSxFQUFFLEVBQUU7WUFDbEMsSUFBSSxZQUFZLEVBQUUsQ0FBQztnQkFDakIsT0FBTztZQUNULENBQUM7WUFFRCxNQUFNLFdBQVcsR0FBRyxHQUFHLE9BQU8sSUFBSSxNQUFNLEVBQUUsQ0FBQztZQUUzQyxZQUFZO2dCQUNWLE1BQU0sQ0FBQyxlQUFlLENBQUMsV0FBVyxDQUFDO29CQUNuQyxNQUFNLENBQUMsZUFBZSxDQUFDLFdBQVcsQ0FBQyxDQUFDO1lBRXRDLFlBQVksQ0FBQyxFQUFFLENBQUMsYUFBYSxFQUFFLGFBQWEsQ0FBQyxDQUFDO1lBRTlDLElBQUksWUFBWSxDQUFDLEtBQUssS0FBSyxjQUFjLEVBQUUsQ0FBQztnQkFDMUMsWUFBWSxDQUFDLFNBQVMsRUFBRSxDQUFDO1lBQzNCLENBQUM7UUFDSCxDQUFDLENBQUMsQ0FBQztRQUVILE9BQU8sR0FBRyxFQUFFO1lBQ1YsWUFBWSxFQUFFLEdBQUcsQ0FBQyxhQUFhLEVBQUUsYUFBYSxDQUFDLENBQUM7WUFDaEQsWUFBWSxFQUFFLFdBQVcsRUFBRSxDQUFDO1FBQzlCLENBQUMsQ0FBQztJQUNKLENBQUM7Q0FDRjtBQUVELGVBQWUscUJBQXFCLENBQUMifQ==